import {createFileRoute} from "@tanstack/react-router";
import {ProfileNotification} from "@/components/profile/notification/ProfileNotification";

export const Route = createFileRoute("/_mainLayout/profile/notification/")({
  component: ProfileNotification,
});
